export default __webpack_public_path__ + "static/media/anquan.96e0f197.svg";